import React from 'react';
import { observer } from 'mobx-react';
import { injectTSDI } from '../core/tsdi';
import { Api } from '../core/api';

const formatTimeLeft = (millis: number) => {
    const totalSeconds = Math.max(0, Math.floor(millis / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value: number) => String(value).padStart(2, '0');
    return `${hours}:${pad(minutes)}:${pad(seconds)}`;
};

export const SessionPanel = observer(() => {
    const { googleUserAuth, expireSession } = injectTSDI(Api);
    const [now, setNow] = React.useState(Date.now());

    React.useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(interval);
    }, []);

    const timeLeft = googleUserAuth ? googleUserAuth.expiresAt - now : 0;

    React.useEffect(() => {
        if (googleUserAuth && timeLeft <= 0) {
            expireSession();
        }
    }, [googleUserAuth, timeLeft, expireSession]);

    if (!googleUserAuth) {
        return null;
    }

    return (
        <div className="flex flex-col gap-0.5 border-t px-2 py-2 group-data-[collapsible=icon]:hidden">
            <span className="truncate text-sm font-bold">
                {googleUserAuth.firstName} {googleUserAuth.lastName}
            </span>
            <span className="truncate text-xs text-muted-foreground">
                {googleUserAuth.email}
            </span>
            <span className="text-xs text-muted-foreground">
                Session ends in {formatTimeLeft(timeLeft)}
            </span>
        </div>
    );
});
